import { render, staticRenderFns } from "./FollowedGroupBox.vue?vue&type=template&id=dda6f190&"
import script from "./FollowedGroupBox.vue?vue&type=script&lang=js&"
export * from "./FollowedGroupBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports